import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, ArrowRight } from "lucide-react";

/**
 * Lightweight re-entry screen shown when a learner resumes a saved session.
 * No overlay, no sparks — simple centred card with two action choices.
 */
export default function ReEntryScreen({ sub_topic, onRevisitRecap, onResume }) {
  return (
    <div className="fade-up max-w-2xl mx-auto" data-testid="re-entry-screen">
      <Card className="rounded-3xl p-8 sm:p-10 bg-white shadow-lg border-slate-100 text-center">
        <div
          className="text-xs uppercase tracking-[0.18em] font-semibold text-slate-400 mb-3"
          data-testid="re-entry-subtopic"
        >
          {sub_topic}
        </div>

        <div className="w-16 h-16 rounded-full bg-sky-50 flex items-center justify-center mx-auto mb-5 ring-1 ring-sky-100">
          <BookOpen className="w-8 h-8 text-sky-500" />
        </div>

        <h2
          className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mb-3"
          data-testid="re-entry-headline"
        >
          Welcome back!
        </h2>

        <p
          className="text-slate-700 text-base sm:text-lg leading-relaxed mb-8"
          data-testid="re-entry-subtext"
        >
          Want to do a quick recap before you continue, or jump right back in?
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={onRevisitRecap}
            className="rounded-full border-2 border-slate-200 text-slate-700 hover:bg-slate-50 px-7 py-6 text-base font-semibold tap-44"
            data-testid="re-entry-revisit-btn"
          >
            <BookOpen className="w-4 h-4 mr-2 text-slate-500" /> Revisit recap
          </Button>
          <Button
            onClick={onResume}
            className="rounded-full bg-sky-500 hover:bg-sky-600 text-white px-7 py-6 text-base font-semibold tap-44"
            data-testid="re-entry-resume-btn"
          >
            Resume where I left off <ArrowRight className="w-5 h-5 ml-1.5" />
          </Button>
        </div>
      </Card>
    </div>
  );
}
